import React from 'react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
import { FAQ, FAQItem } from '../FAQ';
const items: FAQItem[] = [{
  q: 'When should I contact a lawyer?',
  a: 'As early as possible — ideally before you sign, respond or make a decision. Early advice is almost always cheaper and gives you more options than waiting until a problem has escalated.'
}, {
  q: 'What should I bring to the first consultation?',
  a: "Any documents relevant to your matter — contracts, letters, notices, agreements or correspondence — plus a short summary of what has happened. If you're not sure, bring what you have; we'll guide you from there."
}, {
  q: 'Can you help if I am not sure what type of lawyer I need?',
  a: 'Yes. Tell us what has happened and we\'ll direct your enquiry to the most appropriate team. Our "Not sure where to start?" pathway exists for exactly this situation.'
}, {
  q: 'Do you offer fixed fees?',
  a: 'For many matters we can offer fixed or capped fees, and we always explain how we charge before we begin. You approve the approach and costs upfront, with no surprises.'
}, {
  q: 'Can you review a contract before I sign?',
  a: 'Absolutely — reviewing contracts before you sign is one of the most valuable things we do. We identify commercial and legal risks and explain them in plain English.'
}, {
  q: 'Can you help resolve matters without going to court?',
  a: "Yes. We resolve most matters through negotiation, mediation or agreement wherever it's appropriate and proportionate. Court is one option — not the default."
}, {
  q: 'Do you act for both individuals and businesses?',
  a: 'We do. Cullen Macleod acts for business owners, families, property clients, executors and individuals across a broad range of legal matters in WA.'
}, {
  q: 'How do I start?',
  a: "Call us on 08 9389 3999 or send a confidential enquiry. We'll listen, explain your options and agree the next step together."
}];
export function HomeFAQ() {
  return <section id="faq" className="scroll-mt-24 bg-white py-16 lg:py-24" data-id="element-166">
      <Container className="grid grid-cols-1 gap-10 lg:grid-cols-12" data-id="element-167">
        <div className="lg:col-span-4" data-id="element-168">
          <SectionHeading eyebrow="Common questions" title="Answers before you pick up the phone." intro="A few of the questions we hear most often. Have another? Just ask — there's no such thing as a silly legal question." data-id="element-169" />
        </div>
        <div className="lg:col-span-8" data-id="element-170">
          <FAQ items={items} data-id="element-171" />
        </div>
      </Container>
    </section>;
}